<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/weier/rework/label/page" ref="yt" getKey="rows" :columns="columns"> </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'web_customize_weier_label_details_list',
  props: {
    reWorkOrderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      columns: [
        {
          prop: 'printRecord.labelBarcodeNumber',
          label: 'biaoqiantiaomahao'
        },
        {
          prop: 'printRecord.woNo',
          label: 'shengchangongdanhao'
        },
        {
          prop: 'printRecord.packageNumber',
          label: 'baozhuangshuliang'
        },
        {
          prop: 'printRecord.packageNumber',
          label: 'yibaogongliangpinshu'
        },
        {
          prop: 'printRecord.batchNo',
          label: 'picihao'
        },
        {
          prop: 'printRecord.qualityCheckStatus',
          label: 'zhijianzhuangtai',
          type: 'dictionary',
          key: 'LABEL_QUALITY_CHECK_STATUS'
        },
        {
          prop: 'result',
          label: 'pandingjieguo',
          type: 'dictionary',
          key: 'LABEL_DETAILS_DECIDE_RESULT'
        },
        {
          prop: 'againInspectioNo',
          label: 'chongxinsongjiandanhao'
        },
        {
          prop: 'decideByObject.nickname',
          label: 'pandingren'
        },
        {
          prop: 'decideTime',
          label: 'pandingshijian',
          type: 'time'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.reworkId = this.reWorkOrderId;
      this.yt.get(1);
    }, 300);
  }
};
</script>
